import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarningHex = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_10858_20878)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M8 10.6667H8.00667",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8 5.33325V7.99992",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.2082 1.33325C10.5618 1.33333 10.9008 1.47385 11.1508 1.72392L14.2762 4.84925C14.5262 5.09924 14.6668 5.43833 14.6668 5.79192V10.2079C14.6668 10.5615 14.5262 10.9006 14.2762 11.1506L11.1508 14.2759C10.9008 14.526 10.5618 14.6665 10.2082 14.6666H5.79216C5.43857 14.6665 5.09949 14.526 4.8495 14.2759L1.72416 11.1506C1.4741 10.9006 1.33357 10.5615 1.3335 10.2079V5.79192C1.33357 5.43833 1.4741 5.09924 1.72416 4.84925L4.8495 1.72392C5.09949 1.47385 5.43857 1.33333 5.79216 1.33325H10.2082Z",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgWarningHex;
